import axios from 'axios'
import { getAppConfig } from './appConfig'

const PREFIX = '[ApiClient]'

const POLL_INTERVAL_MS = 100
const MAX_WAIT_MS = 10_000

let _getAccessToken = null
let _isLoadingFn = null

export function initApiClient(getAccessTokenFn, isLoadingFn) {
  _getAccessToken = getAccessTokenFn
  _isLoadingFn = isLoadingFn
  console.log(
    `${PREFIX} initialized — token getter registered, isLoading=${isLoadingFn()}`,
  )
}

export function setTokenGetter(fn) {
  console.warn(`${PREFIX} setTokenGetter is deprecated — use initApiClient instead`)
  initApiClient(fn, () => false)
}

const { apiBaseUrl: _baseURL } = getAppConfig()
console.log(`${PREFIX} baseURL=${_baseURL}`)

const apiClient = axios.create({
  baseURL: _baseURL,
})

apiClient.interceptors.request.use(async (config) => {
  if (!_getAccessToken) {
    console.error(`${PREFIX} token getter not registered`, { url: config.url })
    return Promise.reject(new Error(`${PREFIX} token getter not registered`))
  }

  if (_isLoadingFn && _isLoadingFn()) {
    const start = Date.now()
    console.debug(`${PREFIX} Auth0 still loading — waiting for ready state`, { url: config.url })

    try {
      await new Promise((resolve, reject) => {
        const check = () => {
          const elapsed = Date.now() - start
          if (!_isLoadingFn()) {
            console.debug(
              `${PREFIX} Auth0 ready after ${elapsed}ms — proceeding with token acquisition`,
              { url: config.url },
            )
            resolve()
          } else if (elapsed >= MAX_WAIT_MS) {
            console.error(
              `${PREFIX} auth0 isLoading timeout after ${elapsed}ms`,
              { url: config.url },
            )
            reject(new Error(`${PREFIX} auth0 isLoading timeout`))
          } else {
            setTimeout(check, POLL_INTERVAL_MS)
          }
        }
        setTimeout(check, POLL_INTERVAL_MS)
      })
    } catch (err) {
      return Promise.reject(err)
    }
  }

  try {
    const token = await _getAccessToken()
    config.headers.Authorization = `Bearer ${token}`
    return config
  } catch (err) {
    console.warn(
      `${PREFIX} Failed to acquire access token — request cancelled:`,
      err?.message ?? err,
    )
    return Promise.reject(new axios.CanceledError(`${PREFIX} unauthenticated`))
  }
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    const url = error.config?.url
    if (status >= 400) {
      console.warn(`${PREFIX} HTTP ${status} on ${url}`)
    }
    return Promise.reject(error)
  },
)

export default apiClient
